import createAction from '../../services/create-action';

export const SET_SITE_STRUCTURE = 'site-structure/SET';

export const setSiteStructure = createAction(SET_SITE_STRUCTURE);
